import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';

export default {
  computed: {
    fieldsClass() {
      return {
        address2: 'sm:col-span-6',
        address5:
          getFeatureFlag(FEATURE_FLAG.GEMINI_TW) || getFeatureFlag(FEATURE_FLAG.HK_NEW_FORM) ? '' : 'sm:col-span-6',
        address7: 'sm:col-span-6',
        zip: 'sm:col-span-6',
      };
    },
  },
};
